import { createContext } from "react";
import { Maybe } from "true-myth";

import { IPerson } from "types/schedules";

const PersonContext = createContext<IPerson>({
  assignee: Maybe.nothing(),
  shifts: [],
  unavail: Maybe.nothing(),
});

export default PersonContext;
